__webpack_require__.p = "/04-accordion-app/";